import { Link } from "react-router-dom";
import Logo from "../images/logo/logo.png";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

function Navbar() {
  const [nav, setNav] = useState(false);
  const { t, i18n } = useTranslation();

  const openNav = () => {
    setNav(!nav);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <nav>
        {/* mobile */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar__close">
            <i className="fa-solid fa-xmark"></i>
          </div>
          <ul className="mobile-navbar__links">
            <li>
              <Link onClick={openNav} to="/">
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/about">
                {t('nav.about')}
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/price">
                {t('nav.price')}
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/models">
                {t('nav.models')}
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/inspection">
                {t('nav.inspection')}
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/how">
                {t('nav.how')}
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/contact">
                {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </div>

        {/* desktop */}
        <div className="navbar">
          <div className="navbar__img">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" />
            </Link>
          </div>
          <ul className="navbar__links">
            <li>
              <Link className="home-link" to="/">
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link className="about-link" to="/about">
                {t('nav.about')}
              </Link>
            </li>
            <li>
              <Link className="price-link" to="/price">
                {t('nav.price')}
              </Link>
            </li>
            <li>
              <Link className="models-link" to="/models">
                {t('nav.models')}
              </Link>
            </li>
            <li>
              <Link className="inspection-link" to="/inspection">
                {t('nav.inspection')}
              </Link>
            </li>
            <li>
              <Link className="how-link" to="/how">
                {t('nav.how')}
              </Link>
            </li>
            <li>
              <Link className="offer-link" to="/offer">
                {t('nav.offer')}
              </Link>
            </li>
            <li>
              <Link className="contact-link" to="/contact">
                {t('nav.contact')}
              </Link>
            </li>
            <li className="language-switcher">
              <button onClick={() => changeLanguage('tr')} className={i18n.language === 'tr' ? 'active' : ''}>TR</button>
              <button onClick={() => changeLanguage('en')} className={i18n.language === 'en' ? 'active' : ''}>EN</button>
            </li>
          </ul>

          {/* mobile */}
          <div className="mobile-hamb" onClick={openNav}>
            <i className="fa-solid fa-bars"></i>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
